export const SIDEBAR_MENU_HOVER_ENTER_DELAY = 250

export const SIDEBAR_MENU_HOVER_LEAVE_DELAY = 300
